export default {

  approvalAwaitList : {}, // 결재 대기함
  approvalProcessList : {}, // 결재 진행함
  approvalCompleteList : {}, // 완료 문서함
  approvalRejectList : {}, // 반려 문서함

  approvalContent : {},

  securityList : [], // 보안등급 리스트
  priorityList : [] // 중요도 리스트
}
